let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("hPzOn"), load("3j9rr")]).then(() => parcelRequire('quJ0B'));